var urlUtil = require('../../lib/url.es6');
var gravatarUrl = require('gravatar-url');

var IRCCLOUD_UID_HOST_RE = /(?:(.+\.)|\/|(?:^))irccloud\.com(?:\/|$)/;

var UserMixins = {
    // Depends
    // getRawHostmask
    // getRawIdent
    // getRawHost
    // getAccount
    // getRealname
    getMaskParts: function () {
        var mask = this.getRawHostmask();
        if (mask) {
            var parts = mask.split('@');
            if (parts.length === 2 && parts[0] && parts[1]) {
                return parts;
            }
        }
    },
    getIdent: function () {
        var ident = this.getRawIdent() || '';
        if (ident && ident[0] != '~' && this.get('ident_prefix')) {
            ident = this.get('ident_prefix') + ident;
        }
        if (!ident) {
            var parts = this.getMaskParts();
            if (parts) {
                ident = parts[0];
            }
        }
        return ident;
    },
    getHost: function () {
        var host = this.getRawHost() || '';
        if (!host) {
            var parts = this.getMaskParts();
            if (parts) {
                host = parts[1];
            }
        }
        return host;
    },
    getHostMask: function () {
        var hostmask = this.getRawHostmask() || '';
        if (!hostmask) {
            hostmask = this.getHost();
            if (hostmask) {
                var ident = this.getIdent();
                if (ident) {
                    hostmask = ident + '@' + hostmask;
                }
            }
        }
        return hostmask;
    },
    getSensibleRealname: function () {
        var realname = this.getRealname() || '';
        if (realname && (realname.toLowerCase() == 'realname' || realname.toLowerCase() == 'unknown')) {
            realname = '';
        }
        return realname;
    },
    realnameEmail: function () {
        var realname = this.getSensibleRealname();
        return urlUtil.matchEmail(realname);
    },
    irccloudUid: function (options) {
        options = options || {};
        var uid, uidMatch;
        var ident = this.getIdent();
        if (ident) {
            uidMatch = ident.match(/^~?[su]id(\d+)/);
            if (uidMatch) {
                uid = uidMatch[1] - 0;
            }
        }
        var host = this.getHost();
        if (uid && !options.strict) {
            if (host && options.filter_enterprise) {
                // If we have a host, make sure it's either from irccloud
                // or not from mozilla
                // ya: moz-blah.charlton.irccloud.com (irccloud user on moznet)
                // ya: gateway/web/irccloud.com/x-blah (irccloud user on freenode)
                // ya: charlton.irccloud.com (irccloud)
                // ya: blah-cloak (unknown cloak)
                // no: moz-blah-blah.IP (non-irccloud user on moznet)
                // no: gateway/web/mozilla/x-blah (mozilla user on freenode)
                if (host.match(IRCCLOUD_UID_HOST_RE) || (
                    !host.match(/^moz-/) && !host.match(/mozilla/)
                )) {
                    return uid;
                }
            } else {
                return uid;
            }
        } else {
            if (host) {
                var hostmatches = host.match(IRCCLOUD_UID_HOST_RE);
                if (hostmatches) {
                    if (uid) {
                        return uid;
                    } else if (hostmatches[1]) {
                        uidMatch = hostmatches[1].match(/id-(\d+)\..+/);
                        if (uidMatch) {
                            uid = uidMatch[1] - 0;
                            return uid;
                        }
                    }
                }
            }
        }
        if (!uid && !options.numeric && this.connection && this.connection.isTeamServer()) {
            return this.getAccount() || undefined;
        }
    },
    getAvatar: function (options) {
        options = options || {};
        var buffer = this.buffer || options.buffer;
        var Avatar = require('avatar');
        var avatarId = options.avatar_id;
        var avatarUrl = options.avatar_url;
        if (!avatarId && !avatarUrl) {
            var prefix = '';
            if (this.has('target_avatar')) {
                prefix = 'target_';
            }
            avatarId = this.get(prefix + 'avatar');
            avatarUrl = this.get(prefix + 'avatar_url');
        }
        var urlSecure = false;
        if (avatarId && _.isString(avatarId)) {
            if (Avatar.isExternalSecure(avatarId)) {
                avatarUrl = avatarId;
                urlSecure = true;
            } else {
                return {
                    id: avatarId,
                    src: Avatar.idToTemplate(avatarId),
                    external: false
                };
            }
        }
        if (urlSecure || (avatarUrl && _.isString(avatarUrl) && Avatar.isExternalSecure(avatarUrl))) {
            if (this.connection.isSlackOAuth() || options.forceExternal || (buffer && buffer.embedExternalAvatars())) {
                return {
                    id: avatarUrl,
                    src: avatarUrl,
                    external: true
                };
            } else {
                return;
            }
        }

        if (!options.strict && this.connection && this.connection.shouldGuessAvatar()) {
            var uid = this.irccloudUid({
                strict: false,
                numeric: true,
                filter_enterprise: true
            });

            if (uid) {
                var redirectUrl = Avatar.redirectTemplate(uid);
                if (this.connection.session && this.connection.session.id == uid) {
                    return this.connection.session.getUser().getAvatar(options);
                } else {
                    return {
                        id: redirectUrl,
                        src: redirectUrl,
                        external: false,
                        guess: true
                    };
                }
            }

            if (!options.noGravatar) {
                var emailRealname = this.realnameEmail();
                if (emailRealname) {
                    var gravatar = gravatarUrl(emailRealname[0]) + '?size={size}&default=404';
                    return {
                        id: gravatar,
                        src: gravatar,
                        external: true,
                        gravatar: true,
                        guess: true
                    };
                }
            }
        }
    }
};


module.exports = UserMixins;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/mixins/usermixins.js
// module id = +9gY
// module chunks = 1